import React from 'react'
import { Col } from 'reactstrap'

export function Columns ({ xl, lg, md, sm, xs, children }) {
  const minWidth = Math.min(xl || 12, lg || 12, md || 12, sm || 12, xs || 12)
  const colCount = 12 / minWidth
  const items = children
  const totalItems = items.length
  const itemsInColumn = Math.ceil(totalItems / colCount)
  const cols = []
  for (let i = 0; i < colCount; i++) {
    cols.push(items.slice(i * itemsInColumn, (i + 1) * itemsInColumn))
  }
  return cols.map((x, i) => <Col key={i} xl={xl} lg={lg} md={md} sm={sm} xs={xs}>{x}</Col>)
}



// WEBPACK FOOTER //
// ./src/components/columns.js